import React, { useMemo } from "react"
import { ReferenceDataType, withReferenceDataState } from "../../globalStates/ReferenceDataHOC"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import LicencesContents from "./LicencesContents"
import Page from "../../components/Page"

const LicencesPage: React.FC<ReferenceDataType> = ({ refDataState }) => {
    const branding = useLanguageState().getStrings()
    const selectLicencesStates = useExhibitorDataState().getCategories()

    const refLicences = useMemo(
        () => refDataState.getCategories("ORGANIZATION", branding.configuration.licencesPage.categoryWhitelist),
        [branding.configuration.licencesPage.categoryWhitelist, refDataState]
    )

    return (
        <Page description={branding.configuration.licencesPage.pageDescription}>
            <LicencesContents selectedLicencesStates={selectLicencesStates} refCategory={refLicences} />
        </Page>
    )
}

export default React.memo(withReferenceDataState(LicencesPage))
